.summary-icon {
    display: inline-flex;
    vertical-align: text-bottom;
    margin-right: 4px;
}

.sidebar-thread-list-item {
    width: 100%;
    height: 108px;
    padding: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid var(--off-white-dk);
}

.sidebar-thread-list-item:hover {
    background-color: var(--list-hovered);
}

.selected {
    background-color: var(--list-selected);
}
